import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { getDefaultAuthorizedRoute } from "@/utils/defaultAuthorizedRoute";

export const RoleBasedRedirect: React.FC = () => {
  const { t } = useTranslation();
  const { userProfile, isLoading } = useAuthenticatedUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  return <Navigate replace to={getDefaultAuthorizedRoute(userProfile)} />;
};
